import firebase from 'firebase/app';
import 'firebase/storage';

import { useMemo } from 'react';
import { useDownloadURL } from 'react-firebase-hooks/storage';

export interface SeekerResumeState {
  link?: string;
  loading: boolean;
  error?: Error;
}

/**
 * Hook to fetch the download URL for a seeker's resume from Firebase Storage.
 * Memoizes the storage reference to prevent unnecessary re-fetches on component re-renders.
 */
export const useSeekerResume = (seekerId?: string, fileName?: string): SeekerResumeState => {
  const storageRef = useMemo(() => {
    if (!seekerId || !fileName) {
      return null;
    }
    return firebase.storage().ref(`/resumes/seekers/${seekerId}/${fileName}`);
  }, [seekerId, fileName]);

  const [downloadUrl, loading, error] = useDownloadURL(storageRef || undefined);

  return useMemo(
    () => ({
      link: downloadUrl,
      loading,
      error,
    }),
    [downloadUrl, loading, error],
  );
};
